module.exports = __webpack_public_path__ + "graphics/checkout-email-icon.ckh.2990a96720c2ad526bc09480635dee39.svg";